module.exports = __webpack_public_path__ + "img/bootstrap.1363ddc1.png";